import { RichTextComponent } from './rich-text.component';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { QuillInputComponent } from '../quill/quill.component';
import { CommonDirectivesModule } from '../../pipes/directives.module';

@NgModule({
  declarations: [
    RichTextComponent,
    QuillInputComponent,
  ],
  imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, CommonModule, CommonDirectivesModule],
  exports: [
    RichTextComponent,
    QuillInputComponent,
  ],
})
export class RichTextModule {

}
